import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ChatBot } from './components/ChatBot';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ProgramsPage } from './pages/ProgramsPage';
import { ContactPage } from './pages/ContactPage';
import { LoginPage } from './pages/LoginPage';
import { AdminDashboard } from './pages/AdminDashboard';
import { StaffDashboard } from './pages/StaffDashboard';

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={
          <div className="App min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1"><HomePage /></main>
            <Footer />
            <ChatBot />
          </div>
        } />
        <Route path="/about" element={
          <div className="App min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1"><AboutPage /></main>
            <Footer />
            <ChatBot />
          </div>
        } />
        <Route path="/services" element={
          <div className="App min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1"><ServicesPage /></main>
            <Footer />
            <ChatBot />
          </div>
        } />
        <Route path="/programs" element={
          <div className="App min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1"><ProgramsPage /></main>
            <Footer />
            <ChatBot />
          </div>
        } />
        <Route path="/contact" element={
          <div className="App min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1"><ContactPage /></main>
            <Footer />
            <ChatBot />
          </div>
        } />
        
        {/* Auth & Dashboard Routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/staff" element={<StaffDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
